"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var refund_request_reason_1 = require("./refund_request_reason");
var refund_type_selector_1 = require("./refund_type_selector");
var partial_refund_amount_1 = require("./partial_refund_amount");
var refund_request_state_1 = require("./refund_request_state");
var refund_request_details_1 = require("./refund_request_details");
var note_to_other_party_1 = require("./note_to_other_party");
var refund_explanation_1 = require("./refund_explanation");
var refund_request_1 = require("./refund_request");
var ViewContext;
(function (ViewContext) {
    // buyer or seller initiating a refund request,
    // or a seller editing a refund request
    ViewContext["DEFAULT"] = "default";
    // seller updating a refund request which was already
    // already conditionally approved, and is now approving.
    // In this view there is no refund state selector, and
    // submitting the form always approves the refund request.
    ViewContext["CONFIRM"] = "confirm";
})(ViewContext = exports.ViewContext || (exports.ViewContext = {}));
var RefundRequestFormFields = /** @class */ (function (_super) {
    tslib_1.__extends(RefundRequestFormFields, _super);
    function RefundRequestFormFields(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            refundReason: '',
            note: '',
            amount: refund_request_1.getInitialAmount(_this.props.refundRequest, _this.props.userType),
            refundType: refund_request_1.IRefundType.FULL,
            refundState: refund_request_1.getInitialRefundState(_this.props.refundRequest.canConditionallyApprove),
            exchangedAmount: null,
        };
        return _this;
    }
    RefundRequestFormFields.prototype.onRefundReasonChange = function (event) {
        this.setState({ refundReason: event.target.value });
    };
    RefundRequestFormFields.prototype.onNoteChange = function (event) {
        this.setState({ note: event.target.value });
    };
    RefundRequestFormFields.prototype.onRefundTypeChange = function (event) {
        var refundType = event.target.value;
        this.setState({
            refundType: refundType,
            refundState: refund_request_1.mapRefundTypeToRefundState(refundType, this.props.refundRequest.canConditionallyApprove),
        });
    };
    RefundRequestFormFields.prototype.onAmountChange = function (event) {
        var amount = event.target.value;
        if (refund_request_1.needsCurrencyExchange(this.props.order, this.props.userType)) {
            this.setState({
                amount: amount,
                exchangedAmount: refund_request_1.amountInSettlementCurrency(amount, this.props.order),
            });
            return;
        }
        this.setState({ amount: amount });
    };
    RefundRequestFormFields.prototype.onRefundStateChange = function (event) {
        this.setState({ refundState: event.target.value });
    };
    RefundRequestFormFields.prototype.renderRefundExplanation = function () {
        if (this.props.hideRefundExplanation) {
            return null;
        }
        return (React.createElement(refund_explanation_1.default, { userType: this.props.userType, order: this.props.order, refundType: this.state.refundType, refundState: this.state.refundState, refundRequest: this.props.refundRequest, refundAmount: this.state.amount, refundReason: this.state.refundReason }));
    };
    RefundRequestFormFields.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(refund_type_selector_1.default, { refundType: this.state.refundType, onRefundTypeChange: this.onRefundTypeChange, userType: this.props.userType, order: this.props.order, refundRequest: this.props.refundRequest }),
            React.createElement(partial_refund_amount_1.default, { amount: this.state.amount, onAmountChange: this.onAmountChange, refundType: this.state.refundType, order: this.props.order, exchangedAmount: this.state.exchangedAmount, refundRequest: this.props.refundRequest }),
            React.createElement(refund_request_details_1.default, { userType: this.props.userType, order: this.props.order, refundRequest: this.props.refundRequest }),
            React.createElement(refund_request_state_1.default, { userType: this.props.userType, refundState: this.state.refundState, onRefundStateChange: this.onRefundStateChange, refundRequest: this.props.refundRequest, viewContext: this.props.viewContext }),
            React.createElement(refund_request_reason_1.default, { refundReason: this.state.refundReason, onRefundReasonChange: this.onRefundReasonChange, reasons: this.props.reasons, userType: this.props.userType, refundRequest: this.props.refundRequest }),
            this.renderRefundExplanation(),
            React.createElement(note_to_other_party_1.default, { refundReason: this.state.refundReason, userType: this.props.userType, note: this.state.note, onNoteChange: this.onNoteChange, viewContext: this.props.viewContext })));
    };
    tslib_1.__decorate([
        bind_1.default
    ], RefundRequestFormFields.prototype, "onRefundReasonChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], RefundRequestFormFields.prototype, "onNoteChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], RefundRequestFormFields.prototype, "onRefundTypeChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], RefundRequestFormFields.prototype, "onAmountChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], RefundRequestFormFields.prototype, "onRefundStateChange", null);
    return RefundRequestFormFields;
}(React.Component));
exports.default = RefundRequestFormFields;
//# sourceMappingURL=form_fields.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/refund_requests/form_fields.js
// module id = KC8M
// module chunks = 20 21